function formatDateForCalendarUrl(date: Date) {
	return date.toISOString().replace(/-|:|\.\d+/g, '');
}

export default formatDateForCalendarUrl;
